import { retreiveSwitchTimestamp } from "../../../Store/slices/allChats-slice";
import { store } from "../../../Store/store/store";

export function switchClickHandler() {
  const timestamp = Date.now();
  store.dispatch(retreiveSwitchTimestamp(timestamp));
}
